import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClubLogo from '../clubs/ClubLogo';

/**
 * Club logo for session cards. Links to the club page when the viewer is a member.
 */
export function SessionClubLogoLink({
  club,
  clubId: clubIdProp,
  clubName: clubNameProp,
  logoImageUrl: logoProp,
  isClubMember = false,
  size = 'sm',
  className = '',
}) {
  const navigate = useNavigate();
  const clubId = clubIdProp || club?.id;
  const clubName = clubNameProp || club?.name || 'Club';
  const logoImageUrl = logoProp ?? club?.logo_image_url ?? null;

  const logo = (
    <ClubLogo logoImageUrl={logoImageUrl} clubName={clubName} size={size} />
  );

  if (isClubMember && clubId) {
    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/clubs/${clubId}`);
        }}
        className={`rounded-full shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 hover:opacity-90 transition-opacity ${className}`}
        aria-label={`Go to ${clubName}`}
      >
        {logo}
      </button>
    );
  }

  return <span className={`shrink-0 ${className}`}>{logo}</span>;
}

/**
 * Logo + club name row used under session titles on cards.
 */
export function SessionClubIdentity({
  session,
  isClubMember = false,
  className = '',
}) {
  const club = session?.clubs;
  const clubId = session?.club_id || club?.id;
  const clubName = club?.name || session?.clubName;
  const location = club?.location;

  if (!clubName && !clubId) return null;

  return (
    <div className={`flex items-center gap-2 text-sm text-text-secondary mb-2 min-w-0 ${className}`}>
      <SessionClubLogoLink
        club={club}
        clubId={clubId}
        clubName={clubName}
        isClubMember={isClubMember}
        size="sm"
      />
      <span className="font-medium truncate">{clubName}</span>
      {location ? (
        <span className="text-text-muted truncate hidden sm:inline">• {location}</span>
      ) : null}
    </div>
  );
}
